<template>
  <div class="mh-page">
    <AppHeader title="Explore Categories" back />
    <main class="mh-content">
      <SearchBox v-model="search" placeholder="Search categories..." />
      <div class="category-grid">
        <CategoryCard
          v-for="c in filtered"
          :key="c.label"
          :category="c"
          @select="open"
        />
      </div>
      <section class="mh-section">
        <h2 class="mh-section-title">Top Searches</h2>
        <div class="mh-scroll top-searches">
          <span v-for="x in top" :key="x" class="mh-chip">{{ x }}</span>
        </div>
      </section>
    </main>
    <BottomNavigation />
  </div>
</template>
<script>
import AppHeader from "@/components/AppHeader.vue";
import BottomNavigation from "@/components/BottomNavigation.vue";
import SearchBox from "@/components/SearchBox.vue";
import CategoryCard from "@/components/CategoryCard.vue";
export default {
  name: "ExploreView",
  components: { AppHeader, BottomNavigation, SearchBox, CategoryCard },
  data() {
    return {
      search: "",
      top: ["Hotel", "Shop", "PG", "Electronics", "Plot", "Doctor", "Tuition"],
      categories: [
        { label: "News", type: "news", icon: "📰", color: "#ede9fe" },
        { label: "Jobs", type: "job", icon: "💼", color: "#ecfdf5" },
        { label: "Events", type: "event", icon: "📅", color: "#fff7ed" },
        { label: "Business", type: "business", icon: "🏢", color: "#eff6ff" },
        { label: "Property", type: "property", icon: "🏠", color: "#ecfeff" },
        { label: "Buy & Sell", type: "business", icon: "🏷️", color: "#fff1f2" },
        { label: "Offers", route: "/offers", icon: "🎁", color: "#fff1f2" },
        { label: "Food", type: "food", icon: "🍔", color: "#fff7ed" },
        { label: "Hotels", type: "business", icon: "🏨", color: "#eff6ff" },
        { label: "Healthcare", type: "business", icon: "❤️", color: "#ecfdf5" },
        { label: "Education", type: "business", icon: "🎓", color: "#eef2ff" },
        { label: "Services", type: "business", icon: "🛠️", color: "#f5f3ff" },
        { label: "Tourism", type: "business", icon: "🏞️", color: "#ecfeff" },
        {
          label: "Emergency",
          route: "/emergencylist",
          icon: "🚨",
          color: "#fff1f2",
        },
        {
          label: "Daily Needs",
          route: "/dailyneed",
          icon: "🛍️",
          color: "#f0fdf4",
        },
      ],
    };
  },
  computed: {
    filtered() {
      return this.categories.filter((x) =>
        x.label.toLowerCase().includes(this.search.toLowerCase()),
      );
    },
  },
  methods: {
    open(c) {
      this.$router.push(
        c.route || { path: "/list", query: { name: c.type, title: c.label } },
      );
    },
  },
};
</script>
<style scoped>
.category-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-top: 12px;
}

.top-searches {
  margin-top: 10px;
}

@media (max-width: 350px) {
  .category-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
